import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightBadgeComponent } from './insight-badge/insight-badge.component';
import { AppInsightBadgesComponent } from './insight-badges.component';
import { AppReviewBadgeComponent } from './custom-badges/app-review-badge.component';
import { InsightBadgeContainerComponent } from './insight-badge-container.component';
import { SwiperModule } from 'swiper/angular';
import { AppVpcBadgeComponent } from './custom-badges/app-vpc-badge.component';
import { AppClawbackHistoryBadgeComponent } from './custom-badges/app-clawback-history-badge.component';

@NgModule({
  imports: [CommonModule, SwiperModule],
  exports: [
    InsightBadgeComponent,
    AppInsightBadgesComponent,
    AppClawbackHistoryBadgeComponent,
    AppReviewBadgeComponent,
    AppVpcBadgeComponent,
    InsightBadgeContainerComponent
  ],
  declarations: [
    InsightBadgeComponent,
    AppInsightBadgesComponent,
    AppClawbackHistoryBadgeComponent,
    AppReviewBadgeComponent,
    AppVpcBadgeComponent,
    InsightBadgeContainerComponent
  ]
})
export class InsightBadgesModule {}
